module.exports = __webpack_public_path__ + "static/img/no_share.8339710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/default_images/no_share.png
// module id = Ok2g
// module chunks = 95